import { render, staticRenderFns } from "./LectureUnified.vue?vue&type=template&id=4d163643&scoped=true"
import script from "./LectureUnified.vue?vue&type=script&lang=js"
export * from "./LectureUnified.vue?vue&type=script&lang=js"
import style0 from "./LectureUnified.vue?vue&type=style&index=0&id=4d163643&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d163643",
  null
  
)

export default component.exports